<template>
  <div class="container">
    <!-- 头部信息 -->
    <Head title="我的课程" v-if="showHeader" :showLeftIcon="back" ></Head>
<!--    <div class="channel-info">-->
<!--      <div>-->
<!--        <img :src="logoUrl" alt class="channel-img" />-->
<!--        <span class="channel-name">{{ channelName }}</span>-->
<!--      </div>-->
<!--      <div v-if="back" @click="backToCourse" class="back-course">返回课程</div>-->
<!--    </div>-->
    <!-- 介绍 -->
<!--    <div class="intru-box" v-if="courseData.courseId">-->
<!--      <div class="course-title">{{ courseData.courseTitle }}</div>-->
<!--      <div-->
<!--        class="course-description"-->
<!--        v-if="courseData.keywords.length >= 80 && !isShowMoreDes"-->
<!--      >-->
<!--        {{ courseData.keywords.substring(0, 80) + ' ...' }}-->
<!--        <span @click="isShowMoreDes = true" style="color: #4da7f9"-->
<!--          >查看更多</span-->
<!--        >-->
<!--      </div>-->
<!--      <div-->
<!--        class="course-description"-->
<!--        v-if="courseData.keywords.length <= 80 || isShowMoreDes"-->
<!--      >-->
<!--        {{ courseData.keywords }}-->
<!--        <span-->
<!--          @click="isShowMoreDes = false"-->
<!--          style="color: #4da7f9"-->
<!--          v-if="courseData.keywords.length >= 80"-->
<!--          >收起</span-->
<!--        >-->
<!--      </div>-->
<!--    </div>-->
    <div class="prech"></div>
    <!-- 课程tab切换 -->
    <van-tabs v-if="active === 'course'" v-model="courseActiveName">
      <van-tab name="a" title="课程目录" v-if="catalogList.length">
        <van-collapse accordion v-model="directoryActive">
          <van-collapse-item
            :key="index"
            :name="index"
            :title="
              (tourist == 'true' && isRecommend) && item.channelHaveFreeGood
                ? item.catalogName + ' (包含免费试看)'
                : item.catalogName
            "
            v-for="(item, index) in catalogList"
          >
            <CourseVideoLink
              :detail-data="item1"
              :isRecommend="isRecommend"
              :key="'kecheng' + index1"
              @click.native="toVideoPlay(item1, index1)"
              v-for="(item1, index1) in item.courseGoodsList"
            ></CourseVideoLink>
          </van-collapse-item>
        </van-collapse>
        <div
          style="padding: 10px 16px; text-align: center"
          v-if="catalogList.length === 0"
        >
          暂无数据
        </div>
      </van-tab>

<!--      <van-tab name="b" title="考前串讲" v-if="courseTalkList.length">-->
<!--        <div class="item-box">-->
<!--          <div class="item-des van-hairline&#45;&#45;bottom">考前串讲</div>-->
<!--        </div>-->
<!--        <van-collapse accordion v-model="talkExamActive">-->
<!--          <van-collapse-item-->
<!--            :key="index"-->
<!--            :name="index"-->
<!--            :title="-->
<!--              (tourist == 'true' && isRecommend) && item.channelHaveFreeGood-->
<!--                ? item.catalogName + ' (包含免费试看)'-->
<!--                : item.catalogName-->
<!--            "-->
<!--            v-for="(item, index) in courseTalkList"-->
<!--          >-->
<!--            <CourseVideoLink-->
<!--              :detail-data="item1"-->
<!--              :isRecommend="isRecommend"-->
<!--              :key="'kaoqianchuanjiang' + index1"-->
<!--              @click.native="toVideoPlay(item1, index1)"-->
<!--              v-for="(item1, index1) in item.courseGoodsList"-->
<!--            ></CourseVideoLink>-->
<!--          </van-collapse-item>-->
<!--        </van-collapse>-->
<!--        <div-->
<!--          style="padding: 10px 16px; text-align: center"-->
<!--          v-if="courseTalkList.length === 0"-->
<!--        >-->
<!--          暂无数据-->
<!--        </div>-->
<!--      </van-tab>-->

<!--      <van-tab name="c" title="真题解析" v-if="courseTopicList.length">-->
<!--        <div class="item-box">-->
<!--          <div class="item-des van-hairline&#45;&#45;bottom">真题解析</div>-->
<!--        </div>-->
<!--        <van-collapse accordion v-model="topicActive">-->
<!--          <van-collapse-item-->
<!--            :key="index"-->
<!--            :name="index"-->
<!--            :title="-->
<!--              (tourist == 'true' && isRecommend) && item.channelHaveFreeGood-->
<!--                ? item.catalogName + ' (包含免费试看)'-->
<!--                : item.catalogName-->
<!--            "-->
<!--            v-for="(item, index) in courseTopicList"-->
<!--          >-->
<!--            <CourseVideoLink-->
<!--              :detail-data="item1"-->
<!--              :isRecommend="isRecommend"-->
<!--              :key="'zhentijiexi' + index1"-->
<!--              @click.native="toVideoPlay(item1, index1)"-->
<!--              v-for="(item1, index1) in item.courseGoodsList"-->
<!--            ></CourseVideoLink>-->
<!--          </van-collapse-item>-->
<!--        </van-collapse>-->
<!--        <div-->
<!--          style="padding: 10px 16px; text-align: center"-->
<!--          v-if="courseTopicList.length === 0"-->
<!--        >-->
<!--          暂无数据-->
<!--        </div>-->
<!--      </van-tab>-->
    </van-tabs>
    <!-- 习题tab切换 -->
<!--    <van-tabs v-if="active === 'exercise'" v-model="activeName">-->
<!--      <van-tab name="a">-->
<!--        <template #title>-->
<!--          <img-->
<!--            class="tab-img"-->
<!--            src="@/assets/img/h5/courseDetail/xitilianxi.png"-->
<!--          />-->
<!--          <span :class="activeName === 'a' ? 'active' : ''" class="tab-name"-->
<!--            >习题练习</span-->
<!--          >-->
<!--        </template>-->
<!--        <div class="item-box">-->
<!--          <div class="item-des van-hairline&#45;&#45;bottom" v-if="!isRecommend">-->
<!--            最近练习-->
<!--          </div>-->
<!--          <CourseItemDetail-->
<!--            :detail-data="item"-->
<!--            :isRecommend="isRecommend"-->
<!--            :key="index"-->
<!--            @click.native="open(item, 1)"-->
<!--            type="1"-->
<!--            v-for="(item, index) in MyExaminationList"-->
<!--          ></CourseItemDetail>-->
<!--          <div-->
<!--            style="padding: 10px 16px; text-align: center"-->
<!--            v-if="MyExaminationList.length === 0"-->
<!--          >-->
<!--            暂无数据-->
<!--          </div>-->
<!--        </div>-->
<!--      </van-tab>-->

<!--      <van-tab name="b" v-if="!isRecommend">-->
<!--        <template #title>-->
<!--          <img class="tab-img" src="@/assets/img/h5/courseDetail/cuoti.png" />-->
<!--          <span :class="activeName === 'b' ? 'active' : ''" class="tab-name"-->
<!--            >错题本</span-->
<!--          >-->
<!--        </template>-->
<!--        <div class="item-box">-->
<!--          <div class="item-des van-hairline&#45;&#45;bottom">错题本</div>-->
<!--          <CourseItemDetail-->
<!--            :detail-data="item"-->
<!--            :isRecommend="isRecommend"-->
<!--            :key="index"-->
<!--            @click.native="open(item, 6)"-->
<!--            type="2"-->
<!--            v-for="(item, index) in examinationItemWrongList"-->
<!--          ></CourseItemDetail>-->
<!--          <div-->
<!--            style="padding: 10px 16px; text-align: center"-->
<!--            v-if="examinationItemWrongList.length === 0"-->
<!--          >-->
<!--            暂无数据-->
<!--          </div>-->
<!--        </div>-->
<!--      </van-tab>-->

<!--      <van-tab name="c" v-if="!isRecommend">-->
<!--        <template #title>-->
<!--          <img-->
<!--            class="tab-img"-->
<!--            src="@/assets/img/h5/courseDetail/xitishoucang.png"-->
<!--          />-->
<!--          <span :class="activeName === 'c' ? 'active' : ''" class="tab-name"-->
<!--            >习题收藏</span-->
<!--          >-->
<!--        </template>-->
<!--        <div class="item-box">-->
<!--          <div class="item-des van-hairline&#45;&#45;bottom">习题收藏</div>-->
<!--          <CourseItemDetail-->
<!--            :detail-data="item"-->
<!--            :isRecommend="isRecommend"-->
<!--            :key="index"-->
<!--            @click.native="open(item, 7)"-->
<!--            type="3"-->
<!--            v-for="(item, index) in ExaminationItemCollectExamination"-->
<!--          ></CourseItemDetail>-->
<!--          <div-->
<!--            style="padding: 10px 16px; text-align: center"-->
<!--            v-if="ExaminationItemCollectExamination.length === 0"-->
<!--          >-->
<!--            暂无数据-->
<!--          </div>-->
<!--        </div>-->
<!--      </van-tab>-->
<!--    </van-tabs>-->
    <!-- 资料展示 -->
<!--    <div class="item-box" v-if="active === 'datadata'">-->
<!--      <div class="item-des van-hairline&#45;&#45;bottom">资料</div>-->
<!--      <CourseItemDetail-->
<!--        :detail-data="item"-->
<!--        :isRecommend="isRecommend"-->
<!--        :key="index"-->
<!--        @click.native="download(item)"-->
<!--        type="5"-->
<!--        v-for="(item, index) in datumList"-->
<!--      ></CourseItemDetail>-->
<!--      <el-dialog-->
<!--        :close-on-click-modal="false"-->
<!--        :show-close="false"-->
<!--        :visible.sync="submit_status"-->
<!--        width="50%"-->
<!--      >-->
<!--        <p @click="submit_status = false">请联系渠道商开通此课程</p>-->
<!--      </el-dialog>-->
<!--    </div>-->
    <!-- 底部导航 -->
<!--    <div style="height: 50px"></div>-->
<!--    <van-tabbar-->
<!--      @change="onChange"-->
<!--      active-color="#000000"-->
<!--      inactive-color="#D8D8D8"-->
<!--      v-model="active"-->
<!--    >-->
<!--      <van-tabbar-item name="course">-->
<!--        <span>课程</span>-->
<!--        <template #icon="props">-->
<!--          <img-->
<!--            :src="props.active ? tabbarIcon.activeOne : tabbarIcon.inactiveOne"-->
<!--          />-->
<!--        </template>-->
<!--      </van-tabbar-item>-->
<!--      <van-tabbar-item name="exercise">-->
<!--        <span>习题</span>-->
<!--        <template #icon="props">-->
<!--          <img-->
<!--            :src="props.active ? tabbarIcon.activeTwo : tabbarIcon.inactiveTwo"-->
<!--          />-->
<!--        </template>-->
<!--      </van-tabbar-item>-->
<!--      <van-tabbar-item name="datadata" v-if="showData">-->
<!--        <span>资料</span>-->
<!--        <template #icon="props">-->
<!--          <img-->
<!--            :src="-->
<!--              props.active ? tabbarIcon.activeThree : tabbarIcon.inactiveThree-->
<!--            "-->
<!--          />-->
<!--        </template>-->
<!--      </van-tabbar-item>-->
<!--    </van-tabbar>-->
  </div>
</template>
<script>

import Head from '@/components/h5/Head'
import CourseItemDetail from '@/components/h5/CourseItemDetail'
import CourseVideoLink from '@/components/h5/CourseVideoLink'
import tabbarIconActiveOne from '@/assets/img/h5/courseDetail/kecheng-active.png'
import tabbarIconInActiveOne from '@/assets/img/h5/courseDetail/kecheng-inactive.png'
import tabbarIconActiveTwo from '@/assets/img/h5/courseDetail/xiti-active.png'
import tabbarIconInActiveTwo from '@/assets/img/h5/courseDetail/xiti-inactive.png'
import tabbarIconActiveThree from '@/assets/img/h5/courseDetail/ziliao-active.png'
import tabbarIconInActiveThree from '@/assets/img/h5/courseDetail/ziliao-inactive.png'
import * as COURSE_API from '@/api/ChannelCourseAPI'
import * as Examina_API from '@/api/ExaminationAPI'
import * as CHANNEL_INFO_API from '@/api/ChannelAPI'
export default {
  name: "CourseDetail",
  data () {
    return {
      back: true,
      submit_status: false,
      logoUrl: localStorage.getItem('logoUrl') || '',
      channelName: localStorage.getItem('channelName') || '',
      courseId: '',
      ExaminationItemCollectExamination: [], //试题收藏
      courseData: {},
      catalogList: [], //我的课程视频
      courseTalkList: [],   //当前考前串讲目录
      courseTopicList: [],   //当前真题讲解目录
      MyExaminationList: [], //试题列表
      examinationItemWrongList: [],//错题列表
      datumList: [],//资料列表
      isShowMoreDes: false,
      active: 'course',
      activeName: 'a',
      courseActiveName: 'a',
      directoryActive: 0,
      talkExamActive: '',
      topicActive: '',
      tabbarIcon: {
        activeOne: tabbarIconActiveOne,
        inactiveOne: tabbarIconInActiveOne,
        activeTwo: tabbarIconActiveTwo,
        inactiveTwo: tabbarIconInActiveTwo,
        activeThree: tabbarIconActiveThree,
        inactiveThree: tabbarIconInActiveThree,
      },
      isRecommend: false,
      showHeader: true,
      showData: true,
      isPay: true,
      tourist: localStorage.getItem('tourist') || sessionStorage.getItem('tourist')
    };
  },
  components: {
    Head,
    CourseItemDetail,
    CourseVideoLink
  },
  created () {
    //从课程列表进入此课程详细页面
    console.log('从课程列表进入此课程详细页面')
    console.log(this.$route.params)

    // 渠道商对接判断
    if (this.$route.query.cat_id && this.$route.query.token && this.$route.query.c_no) {
      this.isPay=false
      this.courseId = this.$route.query.cat_id
      localStorage.setItem('shangke_token', this.$route.query.token)
      localStorage.setItem('c_no', this.$route.query.c_no)
      this.getCourseInfo()
      this.ChannelFindInfo()
      sessionStorage.setItem('isChannel', 'true')
      localStorage.setItem('cat_id', this.$route.query.cat_id)
      this.back=false
    } else if (this.$route.params.courseData) {
      this.courseData = this.$route.params.courseData
      this.courseId = this.courseData.courseId
      this.isRecommend = this.$route.params.isRecommend
    } else {
      this.courseData = JSON.parse(sessionStorage.getItem('h5curriculumSchedule')).courseData
      this.isRecommend = JSON.parse(sessionStorage.getItem('h5curriculumSchedule')).isRecommend
      this.courseId = this.courseData.courseId
    }
    if(this.isRecommend){
      this.tourist='true'
    }
    if (this.$route.query.tab_index) {
      switch (this.$route.query.tab_index) {
        case '1':
          this.active = 'course'
          break;
        case '2':
          this.active = 'exercise'
          break;
        case '3':
          this.active = 'datadata'
          break;

        default:
          this.active = 'course'
          break;
      }
    }
    if (this.$route.query.show_header == '0') {
      this.showHeader = false
      localStorage.setItem('show_header', this.$route.query.show_header)
    }
    if (this.$route.query.show_data == '0') {
      this.showData = false
      localStorage.setItem('show_data', this.$route.query.show_data)
    }
    if(this.isPay){
       this.isPayList()
    }

   // 一定要在create之后调用，可能渠道商对接的token还未存入localStorage

    if (this.tourist == 'false') {
      if (!localStorage.getItem('shangke_token')) {
        this.$router.push({ path: '/h5/login', query: { c_no: sessionStorage.getItem('c_no') || localStorage.getItem('c_no') } });
      }
    }

  },
  mounted () {
  },
  methods: {
      isPayList () {
        // this.examinationList()//试题
        this.getCatalogList() //我的课程
        // this.CourseTalkInfo() //考前串讲
        // this.CourseTopicInfo()//真题讲解
        // this.getExaminationItemCollectExamination()     //试题收藏
        // this.getExaminationItemWrongExamination()  //错题集合
        // this.GetDatumList() //资料

      },

    ChannelFindInfo () {
      CHANNEL_INFO_API.ChannelFindInfo(null).then(res => {
        this.channelName = res.data.channelName
        this.logoUrl = res.data.logoUrl
        localStorage.setItem('channelName', this.channelName)
        localStorage.setItem('logoUrl', this.logoUrl)
      })
    },
    getCourseInfo () {
      let data = {
        courseId: this.courseId,
        tourist:  this.tourist
      }
      COURSE_API.GetCourseInfo(data)
        .then(res => {
          if (Number(res.code) === 0) {
            this.courseData = res.data
             if(this.courseData == null){
                this.$message.success('渠道商尚未购买此课程')
              }
            if(this.courseData !=null ){
              if(this.courseData.isPay==null|| this.courseData.isPay==0){
                this.isRecommend=true;
                this.isPayList()
              }else if(this.courseData.isPay==1)  {
                this.isRecommend=false;
                this.isPayList()
              }

            }
          } else {
            console.log('err')
          }
        })
    },
    public (courseGood) {
      if (this.isRecommend && courseGood.channelFree) {
        return false
      }

      if (this.isRecommend) {
        this.$message.success('请联系渠道商开通此课程')
        return true
      }
    },
    //下载资料
    download (item) {
      if (this.public(item)) {
        //  this.submit_status=true
        return
      }
      if (item.agentDatumAddress) {
        window.open(item.agentDatumAddress)
      } else {
        window.open(item.datumAddress)
      }
    },
    //actionType 1:开始答题 2重新答题 3继续答题   6错题查看 7收藏查看
    open (data, actionType) {
      if (this.public(data)) {
        return
      }
      //   console.log(actionType)
      //跳转开始答题
      if (actionType === 1) {
        //    console.log(data, 'kkkk')
        if (data.customerExaminationTestLogEntity != null && data.customerExaminationTestLogEntity.isCommit == 2) {
          actionType = 3
        }
        if (data.customerExaminationTestLogEntity != null && data.customerExaminationTestLogEntity.isCommit === 1) {
          actionType = 2
        }
        data.courseId = this.courseId
        let toStartTestdata = {
          actionType: actionType,
          examination: data,
          courseData: this.courseData
        }
        console.log(toStartTestdata)

        setTimeout(() => {
          this.$router.push(
            {
              name: 'StartTestMobile',
              params: toStartTestdata
            }
          )
          sessionStorage.setItem('startTestMobile', JSON.stringify(toStartTestdata))
        }, 200)
      }
      //跳转错题页面
      if (actionType === 6) {
        console.log(data, 'toWarning')
        data.courseId = this.courseId
        let Obj = {
          examination: data,
          courseData: this.courseData,
          pushType: 3,//错题
          actionType: 6
        }
        this.$router.push({
          name: 'WarningAndCollectPage',
          params: Obj
        })
        sessionStorage.setItem('warningAndCollectPage', JSON.stringify(Obj))
      }
      //跳转习题收藏
      if (actionType === 7) {
        data.courseId = this.courseId
        console.log(777)
        let Obj = {
          actionType: 7,
          courseData: this.courseData,
          examination: data,
        }
        this.$router.push({
          name: 'WarningAndCollectPage',
          params: Obj
        })
        sessionStorage.setItem('warningAndCollectPage', JSON.stringify(Obj))
      }


    },
    //跳转视频播放页面
    toVideoPlay (courseGood, index) {
      if (this.public(courseGood)) {
        return
      }
      let voidData = {
        goodsId: courseGood.goodsId,
        courseId: this.courseData.courseId,
        courseName: this.courseData.courseName,
        courseGood: courseGood,
        isRecommend: this.isRecommend,
        index: index,
        tourist:  this.tourist
      }
      setTimeout(() => {
        this.$router.push(
          {
            name: 'VideoPlayMobile',
            params: voidData
          }
        )
        sessionStorage.setItem('videoPlayMobile', JSON.stringify(voidData))
      }, 200)
    },
    //错题集合
    getExaminationItemWrongExamination () {
      let data = {
        courseId: this.courseId,
        tourist:  this.tourist
      }
      Examina_API.getExaminationItemWrongExamination(data).then(res => {
        if (res && Number(res.code) === 0) {
          this.examinationItemWrongList = res.data
        } else {
          this.$message.warning(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    GetDatumList () {
      let data = {
        courseId: this.courseId,
        tourist:  this.tourist
      }
      COURSE_API.GetDatumList(data).then(res => {
        console.log(res)
        this.datumList = res.data
      })
    },
    //试题收藏
    getExaminationItemCollectExamination () {
      let data = {
        courseId: this.courseId,
        tourist:  this.tourist
      }
      Examina_API.getExaminationItemCollectExamination(data).then(res => {
        this.ExaminationItemCollectExamination = res.data
      })
    },
    //试题列表
    examinationList () {
      let data = {
        courseId: this.courseId,
        type: 1,//安卓
        tourist:  this.tourist
      }
      COURSE_API.examinationList(data).then(res => {
        console.log(res)
        this.MyExaminationList = res.data
      })
    },
    //我的课程
    getCatalogList () {
      const loading = this.$loading({
        text: '数据加载中……'
      });
      let data = {
        courseId: this.courseId,
        activeIndex: 1,
        tourist:  this.tourist
      }
      COURSE_API.catalogList(data).then(res => {
        loading.close();
        console.log(res)
        this.catalogList = res.data
      }).catch(err => {
        loading.close();
        console.log(err)
      })
    },
    // 查询考前串讲目录
    CourseTalkInfo () {
      let data = {
        courseId: this.courseId,
        activeIndex: 2,
        tourist:  this.tourist
      }
      COURSE_API.catalogList(data).then(res => {
        console.log(res)
        this.courseTalkList = res.data
      })
    },
    // 查询真题讲解目录
    CourseTopicInfo () {
      let data = {
        courseId: this.courseId,
        activeIndex: 3,
        tourist:  this.tourist
      }
      COURSE_API.catalogList(data).then(res => {
        console.log(res)
        this.courseTopicList = res.data
      })
    },

    backToCourse () {
      this.$router.replace({ path: "/h5/myCourseList" })
    },
    onChange (index) {
      console.log(index)
    },
  },
}
</script>
<style lang="less" scoped>
.intru-box {
  padding: 15px 8px;
  background-color: #fff;
  .course-title {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
  }
  .course-description {
    margin-top: 9px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 26px;
  }
}
// 去除tab的top，bottom的border
/deep/ .van-hairline--top-bottom::after {
  border-width: 0px 0;
}
// 折叠背景置灰
/deep/ .van-collapse-item__content {
  background-color: #fff;
}
// tab下滚动条样式
/deep/ .van-tabs__line {
  width: 20px !important;
  background: linear-gradient(
    161deg,
    rgba(74, 199, 255, 1) 0%,
    rgba(77, 167, 249, 1) 100%
  );
}
.tab-img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.tab-name {
  vertical-align: middle;
  margin-left: 5px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 14px;
  &.active {
    color: #4caefa;
  }
}
.item-box {
  background-color: #ffffff;
  overflow: hidden;
}
.item-des {
  margin-top: 10px;
  padding: 10px 16px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 18px;
  // border-bottom: 1px solid #dadada;
}
.channel-info {
  height: 39px;
  background: #4da7f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 14px;
  .channel-img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    vertical-align: middle;
  }
  .channel-name {
    margin-left: 10px;
    vertical-align: middle;
  }
}

.prech {
  height: 12px;
  background-color: #f9f9f9
}
::v-deep .van-tabs__wrap {
  display: none;
}
::v-deep .van-cell__title {
  position: relative;
  &:before {
    content: '';
    width: 3px;
    height: 13px;
    background: #207AFB;
    position: absolute;
    left: -7px;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 15px;
  }
}
</style>
